import React, { useCallback } from "react";
import { Col } from "antd";

import ScreenCardContainer from "../../../../containers/ScreenCardContainer";
import { getFilterDisplaysForContains } from "../../../../services/display";

// Memoized so we don't re-render every card when only `currentDisplay`
// changes — only the two affected cards (the previously-selected and the
// newly-selected) need to re-render.
function DisplayMapCard({
  display,
  user,
  isCurrent,
  onOpenDisplay,
  onHoverDisplay,
}) {
  const handleClick = useCallback(
    () => onOpenDisplay(display),
    [display, onOpenDisplay],
  );
  const handleMouseEnter = useCallback(
    () => onHoverDisplay(display),
    [display, onHoverDisplay],
  );
  const handleMouseLeave = useCallback(
    () => onHoverDisplay(),
    [onHoverDisplay],
  );

  if (!getFilterDisplaysForContains(display, user)) return null;

  return (
    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      <div
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ScreenCardContainer
          user={user}
          display={display}
          isCurrentDisplay={isCurrent}
        />
      </div>
    </Col>
  );
}

export default React.memo(DisplayMapCard);
